import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'if_the_fac_engaged_either_directly_or_via_industrial_trade_asso'

export const dataPointDefinition = {
  retracedId: 'if_the_fac_engaged_either_directly_or_via_industrial_trade_asso',
  name: 'If the facility engaged (either directly or via industrial trade association or tripartite initiatives) with local & district level trade unions to proactively address issues of concern to the industry, how was the facility involved? (SELECT all that apply with a "X":)',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_ACTIVELY_PARTICIPATES_IN_THE_INITIATIVE',
      text: 'Facility actively participates in the initiative',
      externalIds: [
        {
          id: 'ab-10--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-10--1-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_ACTIVELY_LEADS_THE_INITIATIVE',
      text: 'Facility actively leads the initiative',
      externalIds: [
        {
          id: 'ab-10--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-10--1-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_HAS_BEEN_ACTIVELY_ENGAGED_WITH_THE_INITIATIVE_OVER_THE',
      text: 'Facility has been actively engaged with the initiative over the past 3 years',
      externalIds: [
        {
          id: 'ab-10--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe:',
        externalIds: [
          {
            id: 'ab-10--1-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-10--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-10--1-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-10--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_ACTIVELY_PARTICIPATES_IN_THE_INITIATIVE',
                'FACILITY_ACTIVELY_LEADS_THE_INITIATIVE',
                'FACILITY_HAS_BEEN_ACTIVELY_ENGAGED_WITH_THE_INITIATIVE_OVER_THE',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-18',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25190,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
